import { render, staticRenderFns } from "./AStaffDetailMaintainance.vue?vue&type=template&id=c3563c20&scoped=true"
import script from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
export * from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailMaintainance.vue?vue&type=style&index=0&id=c3563c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3563c20",
  null
  
)

export default component.exports